export const MultiselectToolbar = ({
  x,
  y,
  onClick,
}: {
  x: number
  y: number
  onClick: () => void
}) => {
  return (
    <div
      style={{
        cursor: "pointer",
        zIndex: 1000,
        position: "absolute",
        border: "2px solid #ff7e7e",
        background: "#fff",
        color: "#ff2c2c",
        borderRadius: 12,
        transform: `translate(${x - 80}px, ${y - 35}px)`,
        padding: 4,
      }}
      onClick={onClick}
    >
      Delete All
    </div>
  )
}
